<section [formGroup]="stepForm">
  @if (isRestoreIbb) {
    <mbs-accordion
      #restoreTypeStepAccordion
      size="small"
      [activeIds]="activeIds"
      [closeOthers]="true"
      (panelChange)="panelChangeHandler($event)"
      (panelHidden)="panelHiddenHandler($event)">
      <mbs-accordion-panel
        [headerCustomClasses]="
          activeId !== elementsSelector.id.physicalOrVirtualPanel &&
          selectedInnerMap[elementsSelector.id.physicalOrVirtualPanel][value?.restoreAs]
            ? 'bg-blue-10'
            : ''
        "
        [id]="elementsSelector.id.physicalOrVirtualPanel">
        <ng-container panelTitle>
          <span class="d-flex flex-column">
            <span class="d-block">{{ 'wizards:physicalOrVirtualLabel' | i18next }}</span>
          </span>
        </ng-container>

        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [attr.data-e2e]="elementsSelector.name.notVMRestore"
          [descriptionClasses]="'mt-0'"
          [descriptionOutside]="false"
          [id]="'restore-as-disk-radio-0'"
          [label]="'wizards:physical_disk_label' | i18next"
          [value]="restoreAsDiskEnum.Physical"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <span class="text-xs">{{ 'wizards:physical_disk_subtitle' | i18next }}</span>
          </ng-template>
        </mbs-radio>

        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [descriptionClasses]="'mt-0'"
          [descriptionOutside]="false"
          [disabledSelf]="isRestoreProxmox || (isVMRestore && selectedComputersCount > 1) || disableRestoreAsVirtual"
          [id]="'restore-as-radio-1'"
          [label]="'wizards:virtual_disk_label' | i18next"
          [value]="restoreAsDiskEnum.Virtual"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <div class="text-xs mb-2">{{ 'wizards:virtual_disk_subtitle' | i18next }}</div>
            <mbs-select
              class="mt-2"
              formControlName="selectedFileFormat"
              [boldLabel]="false"
              [clearable]="false"
              [disabledSelf]="isRestoreProxmox || (isVMRestore && selectedComputersCount > 1) || disableRestoreAsVirtual"
              [id]="'file-format-select'"
              [items]="fileFormats"
              [label]="'wizards:virtual_format_label' | i18next"
              [labelSize]="mbsLabelSize.md"
              [showRequiredMark]="false"
              [size]="mbsSize.md"></mbs-select>
          </ng-template>
        </mbs-radio>
      </mbs-accordion-panel>

      <mbs-accordion-panel
        [disabled]="!canRestoreToVM"
        [headerCustomClasses]="
          activeId !== elementsSelector.id.virtualizationPlatformsPanel &&
          selectedInnerMap[elementsSelector.id.virtualizationPlatformsPanel][value?.restoreAs]
            ? 'bg-blue-10'
            : ''
        "
        [id]="elementsSelector.id.virtualizationPlatformsPanel">
        <ng-container panelTitle>
          <span class="d-flex flex-column">
            <span
              class="d-block"
              [class.text-muted]="!canRestoreToVM">
              {{ 'wizards:restoreToVirtualizationPlatform' | i18next }}
            </span>
          </span>
        </ng-container>

        <ng-container panelAppendHeader>
          @if (!canRestoreToVM) {
            <span class="mbs-beta-label type-data-step__agent-version-label p-0 ml-2">
              <span
                class="d-flex align-items-center justify-content-end text-sm fw-semibold text-black bg-cyan-20 py-1 px-2 border-start-0 border-radius-sm">
                <span class="ico ico-Lock"></span>
                <span class="ml-1">
                  <span class="type-data-step__agent-version-message">
                    {{ 'wizards:typeData.restoreToVMMinimumAgentVersion' | i18next }}
                  </span>
                </span>
              </span>
            </span>
          }
        </ng-container>

        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [attr.data-e2e]="elementsSelector.name.RestoreToVMwareVSphere"
          [descriptionClasses]="'mt-0'"
          [descriptionOutside]="false"
          [disabledSelf]="!canRestoreToVM"
          [id]="'restore-as-disk-radio-2'"
          [label]="'wizards:typeData.RestoreToVMwareVSphere.title' | i18next"
          [value]="restoreAsDiskEnum.RestoreToVMwareVSphere"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <span class="text-xs">{{ 'wizards:typeData.RestoreToVMwareVSphere.description' | i18next }}</span>
          </ng-template>
        </mbs-radio>

        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [attr.data-e2e]="elementsSelector.name.RestoreToProxmox"
          [descriptionClasses]="'mt-0'"
          [descriptionOutside]="false"
          [disabledSelf]="!canRestoreToVM"
          [id]="'restore-as-disk-radio-3'"
          [label]="'wizards:typeData.RestoreToProxmox.title' | i18next"
          [value]="restoreAsDiskEnum.RestoreToProxmox"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <span class="text-xs">{{ 'wizards:typeData.RestoreToProxmox.description' | i18next }}</span>
          </ng-template>
        </mbs-radio>

        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [attr.data-e2e]="elementsSelector.name.RestoreToHyperV"
          [descriptionClasses]="'mt-0'"
          [descriptionOutside]="false"
          [disabledSelf]="!canRestoreToVM"
          [id]="'restore-as-disk-radio-4'"
          [label]="'wizards:typeData.RestoreToHyperV.title' | i18next"
          [value]="restoreAsDiskEnum.RestoreToHyperV"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <span class="text-xs">{{ 'wizards:typeData.RestoreToHyperV.description' | i18next }}</span>
          </ng-template>
        </mbs-radio>
      </mbs-accordion-panel>

      @if (isNBF) {
        <mbs-accordion-panel
          [disabled]="!canRestoreInstantToVM"
          [headerCustomClasses]="
            activeId !== elementsSelector.id.instantPanel && selectedInnerMap[elementsSelector.id.instantPanel][value?.restoreAs]
              ? 'bg-blue-10'
              : ''
          "
          [id]="elementsSelector.id.instantPanel">
          <ng-container panelTitle>
            <span class="d-flex flex-column">
              <span
                class="d-block"
                [class.text-muted]="!canRestoreInstantToVM">
                {{ 'wizards:instantRestoreLabel' | i18next }}
              </span>
            </span>
          </ng-container>

          <ng-container panelAppendHeader>
            @if (!canRestoreInstantToVM) {
              <mbs-beta-feature-request
                class="mbs-beta-label p-0"
                [buildName]="betaFeatureBuildName.backupBuilds"
                [featureName]="betaFeatureName.instantRestoreToVirtualizationPlatforms"
                [version]="betaFeatureVersion.instantRestoreToVirtualizationPlatforms"></mbs-beta-feature-request>
            }
          </ng-container>

          <mbs-radio
            formControlName="restoreAs"
            name="restoreAsRadio"
            [attr.data-e2e]="elementsSelector.name.InstantRestoreToProxmox"
            [descriptionClasses]="'mt-0'"
            [descriptionOutside]="false"
            [disabledSelf]="!canRestoreInstantToVM"
            [id]="'restore-as-disk-radio-5'"
            [label]="'wizards:typeData.instantRestoreToProxmox.title' | i18next"
            [value]="restoreAsDiskEnum.InstantRestoreToProxmox"
            (change)="changeRestoreAsHandler($event)">
            <ng-template radioDescription>
              <span class="text-xs">{{ 'wizards:typeData.instantRestoreToProxmox.description' | i18next }}</span>
            </ng-template>
          </mbs-radio>

          <mbs-radio
            formControlName="restoreAs"
            name="restoreAsRadio"
            [attr.data-e2e]="elementsSelector.name.InstantRestoreToHyperV"
            [descriptionClasses]="'mt-0'"
            [descriptionOutside]="false"
            [disabledSelf]="!canRestoreInstantToVM"
            [id]="'restore-as-disk-radio-6'"
            [label]="'wizards:typeData.instantRestoreToHyperV.title' | i18next"
            [value]="restoreAsDiskEnum.InstantRestoreToHyperV"
            (change)="changeRestoreAsHandler($event)">
            <ng-template radioDescription>
              <span class="text-xs">{{ 'wizards:typeData.instantRestoreToHyperV.description' | i18next }}</span>
            </ng-template>
          </mbs-radio>

          <mbs-radio
            formControlName="restoreAs"
            name="restoreAsRadio"
            [attr.data-e2e]="elementsSelector.name.InstantRestoreToDRServer"
            [descriptionClasses]="'mt-0'"
            [descriptionOutside]="false"
            [disabledSelf]="!canRestoreInstantToVM"
            [id]="'restore-as-disk-radio-9'"
            [label]="'wizards:typeData.instantRestoreToDRServer.title' | i18next"
            [value]="restoreAsDiskEnum.InstantRestoreToDRServer"
            (change)="changeRestoreAsHandler($event)">
            <ng-template radioDescription>
              <span class="text-xs">{{ 'wizards:typeData.instantRestoreToDRServer.description' | i18next }}</span>

              @if (isDRServerRestore) {
                <mbs-button
                  class="d-block mt-1"
                  [isCtrl]="true"
                  (click)="selectDRServerClickHandler()">
                  @if (selectedDRServer) {
                    {{ selectedDRServer.name || selectedDRServer.displayName }}
                  } @else {
                    {{ 'wizards:typeData.instantRestoreToDRServer.select' | i18next }}
                  }
                </mbs-button>
              }
            </ng-template>
          </mbs-radio>
        </mbs-accordion-panel>
      }

      @if (canRestoreToCloud) {
        @let cantRestore = !hasRestoreToCloudLicense && !canRestoreToAzure && !canRestoreToEC2;
        @let unsupportedStorage = !canRestoreToCloudStorage;
        <mbs-accordion-panel
          [disabled]="cantRestore || unsupportedStorage"
          [headerCustomClasses]="
            activeId !== elementsSelector.id.cloudPanel && selectedInnerMap[elementsSelector.id.cloudPanel][value?.restoreAs]
              ? 'bg-blue-10'
              : ''
          "
          [id]="elementsSelector.id.cloudPanel">
          <ng-container panelTitle>
            <span
              class="d-flex"
              [class.text-muted]="cantRestore || unsupportedStorage">
              {{ 'wizards:restoreToCloudLabel' | i18next }}
            </span>
            @if (unsupportedStorage && !cantRestore) {
              <span class="d-block text-xs text-gray-600 mt-2">
                {{ 'wizards:restoreToCloudStorageLabel' | i18next }}
              </span>
            }
          </ng-container>

          <ng-container panelAppendHeader>
            @if (cantRestore) {
              <span
                class="d-flex align-items-center justify-content-end h-100 text-sm fw-semibold text-black bg-cyan-20 py-1 px-2 border-start-0 border-radius-sm">
                <span class="ico ico-Lock"></span>
                <span class="ml-1">
                  @if (canBuyLicense) {
                    <mbs-button
                      [isCtrl]="true"
                      (click)="buyRestoreLicense()">
                      {{ 'wizards:restoreToCloudLicense' | i18next }}
                    </mbs-button>
                  } @else {
                    {{ 'shared:licenses.contactProviderLicenseRequired' | i18next }}
                  }
                </span>
              </span>
            }
          </ng-container>

          <div class="d-flex flex-column mb-2">
            <mbs-radio
              formControlName="restoreAs"
              name="restoreAsRadio"
              [attr.data-e2e]="elementsSelector.name.RestoreToEC2"
              [descriptionClasses]="'mt-0'"
              [descriptionOutside]="false"
              [disabledSelf]="unsupportedStorage || (!hasRestoreToCloudLicense && !canRestoreToEC2 && canRestoreToAzure)"
              [id]="'restore-as-disk-radio-7'"
              [label]="'wizards:typeData.ec2Restore.title' | i18next"
              [value]="restoreAsDiskEnum.EC2"
              (change)="changeRestoreAsHandler($event)">
              <ng-template radioDescription>
                <span class="text-xs">{{ 'wizards:typeData.ec2Restore.description' | i18next }}</span>
              </ng-template>
            </mbs-radio>

            @if (!hasRestoreToCloudLicense && !canRestoreToEC2 && canRestoreToAzure) {
              <div class="ml-1">
                <mbs-button
                  class="ml-4"
                  type="success"
                  [size]="mbsSize.sm"
                  (click)="getEC2Request()">
                  {{ 'mbs-ui:cloud-restore.requestPermissionsModalTitle' | i18next: { title: ('mbs-ui:cloud-restore.ec2' | i18next) } }}
                </mbs-button>
              </div>
            }
          </div>

          <div class="d-flex flex-column">
            <mbs-radio
              formControlName="restoreAs"
              name="restoreAsRadio"
              [attr.data-e2e]="elementsSelector.name.RestoreToAzure"
              [descriptionClasses]="'mt-0'"
              [descriptionOutside]="false"
              [disabledSelf]="!canRestoreToCloudStorage || (!hasRestoreToCloudLicense && !canRestoreToAzure && canRestoreToEC2)"
              [id]="'restore-as-disk-radio-8'"
              [label]="'wizards:typeData.awsRestore.title' | i18next"
              [value]="restoreAsDiskEnum.AVM"
              (change)="changeRestoreAsHandler($event)">
              <ng-template radioDescription>
                <span class="text-xs">{{ 'wizards:typeData.awsRestore.description' | i18next }}</span>
              </ng-template>
            </mbs-radio>

            @if (!hasRestoreToCloudLicense && !canRestoreToAzure && canRestoreToEC2) {
              <div class="ml-1">
                <mbs-button
                  class="ml-4"
                  type="success"
                  [size]="mbsSize.sm"
                  (click)="getAzureRequest()">
                  {{ 'mbs-ui:cloud-restore.requestPermissionsModalTitle' | i18next: { title: ('mbs-ui:cloud-restore.azureVM' | i18next) } }}
                </mbs-button>
              </div>
            }
          </div>
        </mbs-accordion-panel>
      }

      @if (canShowItemLvlPanel) {
        <mbs-accordion-panel [id]="elementsSelector.id.itemLvl">
          <ng-container panelTitle>{{ 'wizards:restoreToItemLvl' | i18next }}</ng-container>

          <div class="d-flex flex-column">
            <span>
              {{ 'wizards:restoreToItemLvlText1' | i18next }}
              <mbs-button
                type="primary"
                [block]="false"
                [isCtrl]="true"
                (click)="closeWizard()">
                {{ 'wizards:restoreToItemLvlText2' | i18next }}
              </mbs-button>
              {{ 'wizards:restoreToItemLvlText3' | i18next }}
            </span>

            <mbs-button
              class="mt-2"
              type="primary"
              [size]="mbsSize.sm"
              (click)="closeWizard()">
              {{ 'wizards:closeWizard' | i18next }}
            </mbs-button>
          </div>
        </mbs-accordion-panel>
      }
    </mbs-accordion>
  } @else {
    <mbs-form-group>
      @if (isRestoreHyperV) {
        <div
          class="mb-1"
          [attr.data-e2e]="elementsSelector.name.restoreHyperV">
          <mbs-radio
            formControlName="restoreAs"
            name="restoreAsRadio"
            [descriptionClasses]="'mt-1'"
            [descriptionOutside]="false"
            [disabledSelf]="disableRestoreAsNotVirtual"
            [id]="'restore-as-radio-4'"
            [label]="'wizards:hyperVMachineImport' | i18next"
            [value]="restoreAsDiskEnum.RestoreToHyperVAndImport"
            (change)="changeRestoreAsHandler($event)">
            <ng-template radioDescription>
              <div
                class="text-sm"
                [class.text-muted]="disableRestoreAsNotVirtual">
                {{ 'wizards:hyperVSubtitleImport' | i18next }}
              </div>
            </ng-template>
          </mbs-radio>

          <mbs-radio
            formControlName="restoreAs"
            name="restoreAsRadio"
            [descriptionClasses]="'mt-1'"
            [descriptionOutside]="false"
            [disabledSelf]="disableRestoreAsNotVirtual"
            [id]="'restore-as-radio-2'"
            [label]="'wizards:hyperVMachine' | i18next"
            [value]="restoreAsDiskEnum.RestoreToHyperV"
            (change)="changeRestoreAsHandler($event)">
            <ng-template radioDescription>
              <div
                class="text-sm"
                [class.text-muted]="disableRestoreAsNotVirtual">
                {{ 'wizards:hyperVSubtitle' | i18next }}
              </div>
            </ng-template>
          </mbs-radio>
        </div>
      }

      @if (isRestoreVMWare) {
        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [attr.data-e2e]="elementsSelector.name.restoreVMWare"
          [descriptionClasses]="'mt-1'"
          [descriptionOutside]="false"
          [disabledSelf]="disableRestoreAsNotVirtual"
          [id]="'restore-as-radio-3'"
          [label]="'wizards:vmWareVSphere' | i18next"
          [value]="restoreAsDiskEnum.RestoreToVMware"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <span
              class="text-sm"
              [class.text-muted]="disableRestoreAsNotVirtual">
              {{ 'wizards:vmWareVSphereSubtitle' | i18next }}
            </span>
          </ng-template>
        </mbs-radio>
      }

      @if (isRestoreProxmox) {
        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [attr.data-e2e]="elementsSelector.name.restoreProxmox"
          [descriptionClasses]="'mt-1'"
          [descriptionOutside]="false"
          [disabledSelf]="disableRestoreAsNotVirtual"
          [id]="'restore-as-radio-proxmox-1'"
          [label]="'wizards:proxmoxServer' | i18next"
          [value]="restoreAsDiskEnum.RestoreToProxmox"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <span
              class="text-sm"
              [class.text-muted]="disableRestoreAsNotVirtual">
              {{ 'wizards:proxmoxServerDesc' | i18next }}
            </span>
          </ng-template>
        </mbs-radio>
      }

      @if (!isVMRestore) {
        <mbs-radio
          formControlName="restoreAs"
          name="restoreAsRadio"
          [attr.data-e2e]="elementsSelector.name.notVMRestore"
          [descriptionClasses]="'mt-1'"
          [descriptionOutside]="false"
          [id]="'restore-as-disk-radio-0'"
          [label]="'wizards:physical_disk_label' | i18next"
          [value]="restoreAsDiskEnum.Physical"
          (change)="changeRestoreAsHandler($event)">
          <ng-template radioDescription>
            <span class="text-sm">{{ 'wizards:physical_disk_subtitle' | i18next }}</span>
          </ng-template>
        </mbs-radio>
      }

      <mbs-radio
        formControlName="restoreAs"
        name="restoreAsRadio"
        [descriptionClasses]="'mt-1'"
        [descriptionOutside]="false"
        [disabledSelf]="isRestoreProxmox || (isVMRestore && selectedComputersCount > 1) || disableRestoreAsVirtual"
        [id]="'restore-as-radio-1'"
        [label]="'wizards:virtual_disk_label' | i18next"
        [value]="restoreAsDiskEnum.Virtual"
        (change)="changeRestoreAsHandler($event)">
        <ng-template radioDescription>
          @if (!isRestoreProxmox) {
            <div class="text-sm mb-2">
              {{
                (isRestoreHyperV
                  ? 'wizards:virtualDiskHVSubtitle'
                  : isRestoreVMWare
                    ? 'wizards:virtualDiskWMSubtitle'
                    : 'wizards:virtual_disk_subtitle'
                ) | i18next
              }}
            </div>
            <mbs-select
              class="mt-2"
              formControlName="selectedFileFormat"
              [clearable]="false"
              [disabledSelf]="isRestoreProxmox || (isVMRestore && selectedComputersCount > 1) || disableRestoreAsVirtual"
              [id]="'file-format-select'"
              [items]="fileFormats"
              [label]="'wizards:virtual_format_label' | i18next"
              [showRequiredMark]="false"></mbs-select>
          } @else {
            <span class="text-sm text-muted">{{ 'wizards:comingSoon' | i18next }}</span>
          }
        </ng-template>
      </mbs-radio>
    </mbs-form-group>
  }

  @if (isVMRestore && selectedComputersCount > 1) {
    <mbs-alert
      class="mb-0 mt-3"
      [attr.data-e2e]="elementsSelector.name.multipleMachineAlert"
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:multipleMachineAlert' | i18next }}
    </mbs-alert>
  }
</section>
